import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const SmsCircle: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#44C688" />
    <g clipPath="url(#sms-circle-clip)">
      <path
        d="M13.8435 23.3734C13.0871 23.8621 12.1858 24.0751 11.2911 23.9765C10.3964 23.8779 9.56287 23.4738 8.93067 22.8321L8.37798 22.2909C8.13567 22.0426 8 21.7093 8 21.3622C8 21.015 8.13567 20.6817 8.37798 20.4335L10.7238 18.1086C10.9696 17.8667 11.3004 17.7311 11.645 17.7311C11.9896 17.7311 12.3204 17.8667 12.5661 18.1086C12.814 18.3512 13.1468 18.4871 13.4934 18.4871C13.84 18.4871 14.1729 18.3512 14.4207 18.1086L18.1053 14.4183C18.2283 14.297 18.3259 14.1524 18.3925 13.993C18.4591 13.8335 18.4934 13.6624 18.4934 13.4896C18.4934 13.3167 18.4591 13.1456 18.3925 12.9862C18.3259 12.8268 18.2283 12.6822 18.1053 12.5609C17.8638 12.3147 17.7285 11.9834 17.7285 11.6383C17.7285 11.2932 17.8638 10.9619 18.1053 10.7157L20.439 8.37856C20.6867 8.13588 21.0197 8 21.3662 8C21.7128 8 22.0457 8.13588 22.2935 8.37856L22.8339 8.9321C23.4746 9.56528 23.8781 10.4001 23.9765 11.2962C24.075 12.1923 23.8623 13.0949 23.3743 13.8525C20.8319 17.6051 17.5969 20.8367 13.8435 23.3734Z"
        className="fill-card"
      />
    </g>
    <defs>
      <clipPath id="sms-circle-clip">
        <rect
          width="16"
          height="16"
          className="fill-card"
          transform="translate(8 8)"
        />
      </clipPath>
    </defs>
  </svg>
);
